/**
 * Created by Ning Jiang on 2/7/2018.
 */

import {ILayerConfig, ILayersConfig} from "@nolimitcity/slot-game/bin/core/stage/ILayersConfig";
import {IDeviceDependentConfig} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {
    CustomLayerScaleOptions,
    LayerScaleOption,
    ScaleMethod,
    ScaleTarget
} from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";

export interface IImmortalFruitsLayerConfig extends ILayersConfig {
    readonly BACKGROUND: ILayerConfig;
    readonly REEL_BACKGROUND: ILayerConfig;
    readonly REEL_ATTENTION: ILayerConfig;

    readonly BET_LINES: ILayerConfig;
    readonly FOREGROUND: ILayerConfig;
    readonly SYMBOLS: ILayerConfig;
    readonly SYMBOLS_WIN_ANIM: ILayerConfig;
    readonly REELS_FRAME: ILayerConfig;
    readonly JACKPOT:ILayerConfig,
    readonly BONUS_WHEEL:ILayerConfig,
    readonly LOGO: ILayerConfig;

    // #320
    readonly INITIAL_WIN_AMOUNT_BET_LINES: ILayerConfig;

    readonly WIN_PRESENTATIONS: ILayerConfig,
    readonly BIG_WIN: ILayerConfig;
    readonly WIN_COUNT_UP: ILayerConfig;

    readonly DEBUG_OVERLAY: ILayerConfig;
    readonly INTRO: ILayerConfig;
    readonly DEMO: ILayerConfig;
}

export class ImmortalFruitsLayerConfig {
    public static defaultLayerScaleOptions: IDeviceDependentConfig<LayerScaleOption> = {
        desktop: {landscape: LayerScaleOption.REELS_FIT_STAGE},
        mobile: {
            landscape: LayerScaleOption.REELS_FIT_STAGE,
            portrait: LayerScaleOption.REELS_FIT_STAGE
        }
    };

    public static customOptions: CustomLayerScaleOptions = {
        frame: {x: 0, y: 0, width: 720, height: 620},
        placement: {
            desktop: {
                landscape: {x: 0.5, y: 0.5}
            },
            mobile: {
                landscape: {x: 0.5, y: 0.5},
                portrait: {x: 0.5, y: 0.5}
            }
        },
    };

    public static reelBackground: CustomLayerScaleOptions = {
        target: {
            desktop: {
                landscape: ScaleTarget.STAGE
            },
            mobile: {
                landscape: ScaleTarget.STAGE,
                portrait: ScaleTarget.WINDOW
            }
        },
        placement: {
            desktop: {
                landscape: {x: 0.5, y: 1}
            },
            mobile: {
                landscape: {x: 0.5, y: 1},
                portrait: {x: 0.5, y: 1}
            }
        },
        method: {
            desktop: {
                landscape: ScaleMethod.FIT
            },
            mobile: {
                landscape: ScaleMethod.FIT,
                portrait: ScaleMethod.FIT
            }
        }
    };

    public static introConfig: CustomLayerScaleOptions = {
        target: ScaleTarget.WINDOW,
        method: ScaleMethod.FIT,
        frame: {x: 0, y: 0, width: 720, height: 720},
        placement: {x: 0.5, y: 0.5}
    };

    public static BACKGROUND: ILayerConfig = {
        name: "BACKGROUND",
        customOptions: ImmortalFruitsLayerConfig.introConfig
    };

    public static REEL_BACKGROUND: ILayerConfig = {
        name: "REEL_BACKGROUND",
        customOptions: ImmortalFruitsLayerConfig.reelBackground
    };

    public static REEL_ATTENTION: ILayerConfig = {
        name: "REEL_ATTENTIONS",
        customOptions: ImmortalFruitsLayerConfig.customOptions
    };

    public static BET_LINES: ILayerConfig = {
        name: "BET_LINES",
        customOptions: ImmortalFruitsLayerConfig.customOptions
    };

    public static FOREGROUND: ILayerConfig = {
        name: "FOREGROUND",
        customOptions: ImmortalFruitsLayerConfig.customOptions
    };
    public static SYMBOLS: ILayerConfig = {
        name: "symbols",
        customOptions: ImmortalFruitsLayerConfig.customOptions
    };

    public static SYMBOLS_WIN_ANIM: ILayerConfig = {
        name: "symbolsWinAnim",
        customOptions: ImmortalFruitsLayerConfig.customOptions
    };

    public static REELS_FRAME: ILayerConfig = {
        name: "reelsFrame",
        customOptions: ImmortalFruitsLayerConfig.customOptions
    };
    public static JACKPOT: ILayerConfig = {
        name: "JACKPOT",
        customOptions: ImmortalFruitsLayerConfig.customOptions
    };
    public static BONUS_WHEEL: ILayerConfig = {
        name: "BONUS_WHEEL",
        customOptions: ImmortalFruitsLayerConfig.customOptions
    };

    public static WIN_PRESENTATIONS: ILayerConfig = {
        name: "WIN_PRESENTATIONS",
        customOptions: ImmortalFruitsLayerConfig.customOptions
    };

    public static WIN_COUNT_UP: ILayerConfig = {
        name: "WIN_COUNT_UP",
        customOptions: ImmortalFruitsLayerConfig.customOptions
    };

    public static LOGO: ILayerConfig = {
        name: "LOGO",
        customOptions: ImmortalFruitsLayerConfig.customOptions
    };

    public static DEBUG_OVERLAY: ILayerConfig = {
        name: "DEBUG_OVERLAY",
        scaleOption: LayerScaleOption.NONE
    };

    public static INTRO: ILayerConfig = {
        name: "intro",
        customOptions: ImmortalFruitsLayerConfig.introConfig
    };

    public static BIG_WIN: ILayerConfig = {
        name: "BIG_WIN",
        customOptions: ImmortalFruitsLayerConfig.customOptions
    };
    public static BIG_WIN_FOUNTAIN: ILayerConfig = {
        name: "BIG_WIN_FOUNTAIN",
        customOptions: ImmortalFruitsLayerConfig.customOptions
    };
    public static BIG_WIN_LIGHTS: ILayerConfig = {
        name: "BIG_WIN_LIGHTS",
        customOptions: ImmortalFruitsLayerConfig.customOptions
    };

    public static DEMO: ILayerConfig = {
        name: "DEMO",
        customOptions: ImmortalFruitsLayerConfig.customOptions
    };

    // #320
    private static INITIAL_WIN_AMOUNT_BET_LINES: ILayerConfig = {
        name: "INITIAL_WIN_AMOUNT_BET_LINES",
        customOptions: this.customOptions
    };

    public static getConfig(): IImmortalFruitsLayerConfig {
        return {
            BACKGROUND: ImmortalFruitsLayerConfig.BACKGROUND,
            REEL_BACKGROUND: ImmortalFruitsLayerConfig.REEL_BACKGROUND,
            REEL_ATTENTION: ImmortalFruitsLayerConfig.REEL_ATTENTION,
            FOREGROUND:ImmortalFruitsLayerConfig.FOREGROUND,
            SYMBOLS: ImmortalFruitsLayerConfig.SYMBOLS,
            SYMBOLS_WIN_ANIM: ImmortalFruitsLayerConfig.SYMBOLS_WIN_ANIM,
            REELS_FRAME: ImmortalFruitsLayerConfig.REELS_FRAME,
            JACKPOT:ImmortalFruitsLayerConfig.JACKPOT,
            BET_LINES: ImmortalFruitsLayerConfig.BET_LINES,
            BONUS_WHEEL:ImmortalFruitsLayerConfig.BONUS_WHEEL,
            LOGO: ImmortalFruitsLayerConfig.LOGO,

            INITIAL_WIN_AMOUNT_BET_LINES: this.INITIAL_WIN_AMOUNT_BET_LINES,

            WIN_PRESENTATIONS: ImmortalFruitsLayerConfig.WIN_PRESENTATIONS,
            BIG_WIN_LIGHTS: ImmortalFruitsLayerConfig.BIG_WIN_LIGHTS,
            BIG_WIN_FOUNTAIN: ImmortalFruitsLayerConfig.BIG_WIN_FOUNTAIN,
            BIG_WIN: ImmortalFruitsLayerConfig.BIG_WIN,
            WIN_COUNT_UP: ImmortalFruitsLayerConfig.WIN_COUNT_UP,

            DEBUG_OVERLAY: ImmortalFruitsLayerConfig.DEBUG_OVERLAY,
            INTRO: ImmortalFruitsLayerConfig.INTRO,
            DEMO: ImmortalFruitsLayerConfig.DEMO
        };
    }
}